import React, { useEffect, useState } from "react";
import { Carousel, Image, Modal } from "react-bootstrap-v5";
import {
  BASE_URL,
  GET_SITESETTINGS,
  GET_SLIDERSETTINGS,
} from "../../constant/constants";

const Hero = () => {
  const [contents, setContents] = useState([]);
  const [show, setShow] = useState(false);
  const [modalImage, setModalImage] = useState({});
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const updateWindowDimensions = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    fetch(`${GET_SLIDERSETTINGS}`)
      .then((response) => response.json())
      .then((data) => {
        setContents(data.homepage_sliders);
      });

    handleShow();

    fetch(GET_SITESETTINGS)
      .then((response) => response.json())
      .then((data) => {
        setModalImage(data.general_settings[0]);
      })
      .catch(() => {});

    window.addEventListener("resize", updateWindowDimensions);

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const imageHeight = windowWidth < 600 ? "600px" : "600px";
  return (
    <div
    // style={{
    //   marginTop: "64.5px",
    // }}
    >
      {modalImage?.slider && (
        <Modal size="lg" show={show} centered onHide={handleClose}>
          <Image
            fluid={true}
            thumbnail={true}
            rounded={true}
            style={{
              filter: "brightness(80%)",
            }}
            src={`${BASE_URL}${modalImage?.slider}`}
            alt="First slide"
          />
        </Modal>
      )}
      <Carousel fade>
        {contents.map((n, index) => (
          <Carousel.Item key={index} interval={5000}>
            <img
              className="d-block w-100 carousel-img"
              // style={{
              //   height: imageHeight,
              //   objectFit: "contain", // Ensures image covers entire area without stretching
              // }}
              src={`${BASE_URL}${n.image}`}
              alt={`Slide ${index + 1}`}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default Hero;
